import type { JSX } from 'react';

import type { EnrollmentResult } from '../../lib/ffs-api.js';

/** Post-enroll view. `'enrolling'` is the in-flight state; the page fires the redirect on `enrolled`. */
export function EnrollmentOutcome({
  result,
  onRetry,
}: {
  result: EnrollmentResult | 'enrolling';
  onRetry: () => void;
}): JSX.Element {
  if (result === 'enrolling') {
    return (
      <p className="flex items-center gap-3 text-lg text-[var(--ink-soft)]">
        <span
          className="size-4 shrink-0 animate-spin rounded-full border-2 border-[var(--color-field-border)] border-t-[var(--coral)]"
          aria-hidden="true"
        />
        Enrolling…
      </p>
    );
  }
  if (result.kind === 'enrolled') {
    return (
      <p className="text-lg text-[var(--ink)]">
        You&apos;re enrolled! Taking you to schedule your consult…
      </p>
    );
  }
  if (result.kind === 'blocked' || result.kind === 'booking_unavailable') {
    return <p className="text-lg text-[var(--ink)]">{result.message}</p>;
  }
  return (
    <div className="flex flex-col gap-4">
      <p className="text-[var(--ink)]">{result.message}</p>
      <button
        className="rounded-full border border-[var(--color-field-border)] px-6 py-3 font-medium text-[var(--forest)] hover:bg-[var(--forest-5)]"
        type="button"
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
}
